import appBar from './appBar';
import common from './common';
import email from './email';
import { footer } from './footer';
import preview from './preview';
import question from './question';

const resources = {
  en: {
    translation: {
      appBar: appBar.en,
      footer: footer.en,
      preview: preview.en,
      common: common.en,
      question: question.en,
      email: email.en,
    },
  },
  ja: {
    translation: {
      appBar: appBar.ja,
      footer: footer.ja,
      preview: preview.ja,
      common: common.ja,
      question: question.ja,
      email: email.ja,
    },
  },
};

export default resources;